import { EVENT_ACTIONS } from 'modules/app/services/datahub/constants';
import DatahubService from 'modules/app/services/datahub/DatahubService';
import { buildInteractionEventData } from 'modules/app/services/datahub/helper';
import * as GA from 'modules/app/services/ga/constants';
import GtagService from 'modules/app/services/ga/GtagService';

const ANALYTICS_EVENTS = GtagService.createEvents({
  common: {
    name: GA.CATEGORIES.SETTINGS,
    category: GA.CATEGORIES.SETTINGS
  },
  [GA.LABELS.TOGGLE_ON]: {
    action: GA.ACTIONS.FREE_SIGN_UP,
    label: GA.LABELS.TOGGLE_ON
  },
  [GA.LABELS.TOGGLE_OFF]: {
    action: GA.ACTIONS.FREE_SIGN_UP,
    label: GA.LABELS.TOGGLE_OFF
  }
});

export default {
  freeSignUpToggle: (checked) => {
    const event = checked
      ? ANALYTICS_EVENTS[GA.LABELS.TOGGLE_ON]
      : ANALYTICS_EVENTS[GA.LABELS.TOGGLE_OFF];

    event && GtagService.send(event);

    const action = checked ? GA.LABELS.TOGGLE_ON : GA.LABELS.TOGGLE_OFF;
    const label = checked ? GA.ACTIONS.FREE_SIGN_UP : GA.ACTIONS.FREE_SIGN_UP;

    DatahubService.sendEvent({
      action: EVENT_ACTIONS.INTERACT,
      event: buildInteractionEventData({
        category: GA.CATEGORIES.SETTINGS,
        action,
        label
      })
    });
  }
};
